const KeenSlider = window.KeenSlider

const { setInitialised, useProgress } = window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 2,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3,
              spacing: 2,
            },
          },
        },
      },
      [
        setInitialised(),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
